import { useState, useEffect } from 'react';
import { authenticatedFetch } from '../../../../utils/api';

export const useDashboardData = ({ isAuthenticated }) => {
    const [dashboards, setDashboards] = useState([]);
    const [dashboardsLoaded, setDashboardsLoaded] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!isAuthenticated || dashboardsLoaded) return undefined;

        let cancelled = false;

        const loadDashboards = async () => {
            try {
                const res = await authenticatedFetch('/ManagerReport/GetUserDashboards', { method: 'GET' });
                if (!res.ok) throw new Error('Failed to fetch dashboards');
                const data = await res.json();
                if (!cancelled) setDashboards(Array.isArray(data) ? data : []);
            } catch (ex) {
                console.error('Background dashboard load failed:', ex);
                if (!cancelled) setError(ex.message);
            } finally {
                if (!cancelled) setDashboardsLoaded(true);
            }
        };

        loadDashboards();
        return () => { cancelled = true; };
    }, [isAuthenticated, dashboardsLoaded]);

    return { dashboards, dashboardsLoaded, error };
};
